import { useState } from "react"
import { Box, Text, Flex, Heading, Stack, Button, useColorMode, IconButton, Link} from "@chakra-ui/react"
import { HamburgerIcon } from "@chakra-ui/icons"

type NavbarProps = {
    showNavbar : boolean,
    setShowNavbar: (showNavbar: boolean) => void 
}

export const Navbar = ({showNavbar} : NavbarProps) => {
    const { toggleColorMode } = useColorMode()
    const [displayMenu, setDisplayMenu] = useState(false)

    // add style object and change based on displayMenu value
    const navbarStyle = {
        position: "fixed", top: showNavbar ? "0" : "-8rem", left: "0", right: "0",
        bg: "container_bg",
        p: "2.5rem", pt: "1.5rem", pb: "1.5rem", borderRadius: "20px", margin: "1rem auto", width: ["90%", null, null, "95%"], maxWidth: "100vw",
        border: "solid 0.5px var(--chakra-colors-container_outline)",
        justifyContent: "center", alignItems: "center",
        boxShadow: "0px 0px 8px 0px var(--chakra-colors-container_shadow)",
        zIndex: "popover",
        transition: "0.8s",
        // transitionDelay: "0.3s",
        // transitionProperty: ""

    }


    function MenuLinks() {
        return (
        <Stack transition="0.25s" direction={["column", null, null, "row"]} mt={["1rem", null, null, "0rem"]} alignItems="center" spacing="2rem">
            <Button onClick={() => {
                setDisplayMenu(false)
                document.getElementById("HOME")?.scrollIntoView({ behavior: "smooth" })
            }}
                _hover={{
                        color: "accent" }}
                color="body_text">
                <Heading fontSize="1rem" variant="special" as="span">HOME</Heading>
                <Heading  fontSize="1rem" variant="special" as="span" color="#FF9820" >.</Heading>
            </Button>
            <Button onClick={() => {
                document.getElementById("ABOUT")?.scrollIntoView({ behavior: "smooth" })
                setDisplayMenu(false)
            }}_hover={{
                color: "accent" }}
        color="body_text">
                <Heading fontSize="1rem" variant="special" as="span">ABOUT</Heading>
                <Heading fontSize="1rem" variant="special" as="span" color="#FF9820" >.</Heading>
            </Button>
            <Button onClick={() => {
                document.getElementById("PROJECTS")?.scrollIntoView({ behavior: "smooth" })
                setDisplayMenu(false)

            }}_hover={{
                color: "accent" }}
        color="body_text">
                <Heading fontSize="1rem" variant="special" as="span">PROJECTS</Heading>
                <Heading fontSize="1rem" variant="special" as="span" color="#FF9820" >.</Heading>
            </Button>
            <Button onClick={() => {
                document.getElementById("CONTACT")?.scrollIntoView({ behavior: "smooth" })
                setDisplayMenu(false)
            }}_hover={{
                color: "accent" }}
        color="body_text">
                <Heading fontSize="1rem" variant="special" as="span">CONTACT</Heading>
                <Heading fontSize="1rem" variant="special" as="span" color="#FF9820" >.</Heading>
            </Button>

        </Stack>

        )
    }
    return (
        <Box  transition="0.24s" >
            <Flex direction="column" sx={displayMenu ? navbarStyle : navbarStyle}>
                <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
                    <Link onClick={toggleColorMode}><Text fontWeight="medium" fontSize="20px">Ahmed Imana.</Text></Link>
                    <Box display={["none", null, null, "block"]}>{MenuLinks()}</Box>
                    
                    <IconButton display={["block", null, null, "none"]} aria-label="Navmenu" onClick={(e) => setDisplayMenu((prev) => !prev)} icon={<HamburgerIcon />} />

                </Stack>
                    <Box overflow="hidden" transition="max-height 0.8s" maxHeight={displayMenu ? "100vh" : "0"} display={["block", null, null, "none"]}>
                        {/* <Collapse in={displayMenu && showNavbar} unmountOnExit={false} >  */}
                        {MenuLinks()}
                        {/* </Collapse>  */}
                    </Box>
            </Flex>


        </Box>
    )
}